var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"tasks-table-block"},[_c('h2',{staticClass:"tasks-table-block__title"},[_vm._v(_vm._s(_vm.$t("label.tasks")))]),_c('ToDoTasksTableTabs',_vm._b({on:{"row-click":_vm.navigateTask}},'ToDoTasksTableTabs',_vm.tableProps,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }